import React from "react"
import Section from "@components/section"
import Title from "@components/title"
import Frame from "@components/frame"
import classnames from "@utils/classnames"
import styles from "./market.module.scss"

import jikaosiImage from "@images/shops/jikaosi.png"
import heshiImage from "@images/shops/heshi.png"
import shinobiImage from "@images/shops/shinobi.png"

const SHOPS = [
  {
    image: jikaosiImage,
    desc: (
      <>
        今年有超酷的多款限定场贩
        <br />
        还有全新的机组系列
      </>
    ),
    link: null,
  },
  {
    image: heshiImage,
    desc: (
      <>
        首次设立有声书体验区域
        <br />
        多款核市奇谭独家场贩周边
      </>
    ),
    link: null,
  },
  {
    image: shinobiImage,
    desc: (
      <>
        剑玉游戏挑战
        <br />
        在这里迎接大家
      </>
    ),
    link: null,
  },
]

const renderItem = ({ desc, image, link }) => {
  return (
    <Frame
      key={image}
      className={styles.item}
      withArrow={link}
      withComingSoon={!link}
      clickable={link}
      href={link}
    >
      <div className={styles.itemImage}>
        <img src={image} />
      </div>
      <p>{desc}</p>
    </Frame>
  )
}

const Market = React.memo(props => {
  return (
    <Section id="block-market">
      <Title>除了打游戏，你也能在这里找到</Title>
      <Frame.OutlineContainer className={styles.shops}>
        {SHOPS.map(item => {
          return renderItem(item)
        })}
      </Frame.OutlineContainer>
      <p className="textCenter fontSm mt">
        除了以上读库·御宅学、次元书馆、后浪、新星出版社、北京棋玩俱乐部、星辰铸造、乐博睿、柏龙、帝企鹅、极想、JELLYCUBE、FANTHFUL
        <br />
        骑士幻旅、极游、501军团、BiBisama也会在现场与你见面！
      </p>
    </Section>
  )
})

Market.displayName = "Market"
export default Market
